import { AddressCreateDirectiveModule } from '@b2b/common/directives/address/create/create.directive';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO } from '@b2b/types/core/utils';
import angular, { IScope } from 'angular';

CreateEditAddressModalController.$inject = [
  '$scope',
  '$uibModalInstance',
  'ApiService',
  'ValidateService',
  'address',
  'organizationId',
  'preventSave',
];

function CreateEditAddressModalController(
  $scope: IScope & { createEditAddressModal: TODO },
  $uibModalInstance: TODO,
  ApiService: ApiService,
  ValidateService: TODO,
  address: TODO,
  organizationId: TODO,
  preventSave: TODO
) {
  const ctrl = {
    title: 'Add Address',

    errors: [],

    model: {},

    createAddress: false,
    address: false,

    preventSave: false,

    init: function () {
      if (address) {
        this.title = 'Edit Address';
        this.model = address;
      }

      if (organizationId) {
        this.organizationId = organizationId;
      }

      if (preventSave) {
        this.preventSave = preventSave;
      }

      $scope.$on('AddressList::Create', this.onAddressListCreate);
      $scope.$on('AddressCreate::Complete', this.onAddressCreateComplete);
    },

    getAddress: function () {
      ApiService.organizations.contacts
        .detail({
          organizationId: organizationId,
          // contactId: contact.id, // TODO: is this still needed?
        })
        .then(this.success.getAddress, this.error.getAddress);
    },

    done: function () {
      $scope.$broadcast('AddressCreate::Process');
    },

    cancel: function () {
      $uibModalInstance.dismiss('cancel');
    },

    success: {
      getAddress: function (response) {},
    },

    error: {
      getAddress: function (response) {},
    },

    onAddressListCreate: function (e, data) {
      ctrl.createAddress = true;
    },

    onAddressCreateComplete: function (e, data) {
      $uibModalInstance.close(data.address);
    },
  };

  $scope.createEditAddressModal = ctrl;
  ctrl.init();
}

export const PartnersCreateCreateEditAddressModalControllerModule = angular
  .module('acme.view.application.partners.create.createEditAddressModal.controllers', [
    'acme.common.service.api',
    'acme.common.service.validate',
    AddressCreateDirectiveModule,
  ])
  .controller('CreateEditAddressModalController', CreateEditAddressModalController).name;
